<template>
<div v-if="current">
    <spinningModal v-if="showSpinner"></spinningModal>
    <div>
        <div class="panel-content panel-top" v-if="seasonBreakInfos">
            <h5> La saison de cette équipe est actuellement terminée, voici les infos d'intersaison :</h5>
          <template v-if="$store.getters.currentUser.is_superuser && currentMode === 'read' ">
            <button class="" @click="currentMode = 'write' ">Customiser les infos d'intersaison</button>
            <button class="alert" @click="cancelSBI()">Annuler le passage a l'intersaison</button>
          </template>
          <template v-if="currentMode === 'write' ">
            <button class="light-grey-button" @click="currentMode = 'read'">Retour</button>
            <button class="validate" @click="updateCustomSBI() ">Valider les customisations</button>
          </template>
            <div id="allplayers" class="row columns">
              <hr>
                  <team-s-b-i-infos :mode="currentMode" :season-break-infos="seasonBreakInfos" :team="current" ref="teamSBI"></team-s-b-i-infos>
              <hr>
                <div id="starplayer" v-if="current.rostered_star_player" class="large-12">
                    <div class="inner-title">La Star de l'équipe : </div>
                    <table>
                        <thead class="star">
                            <tr>
                                <th width="100">Nom</th>
                                <th width="5">M</th>
                                <th width="5">F</th>
                                <th width="5">Ag</th>
                                <th width="5">Ar</th>
                                <th width="225">Compétences</th>
                                <th width="10">Réu</th>
                                <th width="10">Td</th>
                                <th width="10">Int</th>
                                <th width="10">Sor</th>
                                <th width="10">Mvp</th>
                                <th width="50">Prix</th>
                            </tr>
                        </thead>
                        <tbody class="star">
                            <tr>
                                <td>{{current.rostered_star_player.ref_star_player.name}}</td>
                                <td>{{current.rostered_star_player.ref_star_player.M}}</td>
                                <td>{{current.rostered_star_player.ref_star_player.F}}</td>
                                <td>{{current.rostered_star_player.ref_star_player.Ag}}</td>
                                <td>{{current.rostered_star_player.ref_star_player.Ar}}</td>
                                <td>
                                    <span v-for="skill in current.rostered_star_player.ref_star_player.skills" >
                                            {{skill.name}},
                                    </span>
                                </td>
                                <td>{{current.rostered_star_player.nb_passes}}</td>
                                <td>{{current.rostered_star_player.nb_TD}}</td>
                                <td>{{current.rostered_star_player.nb_int}}</td>
                                <td>{{current.rostered_star_player.nb_cas}}</td>
                                <td>{{current.rostered_star_player.nb_MVP}}</td>
                                <td><span class="additional_skills">{{current.rostered_star_player.ref_star_player.cost}}k</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div id="regularplayers" class="large-12">
                    <div class="inner-title">Les Joueurs : </div>
                    <table>
                         <thead class="roster">
                             <tr>
                             <th width="40">N°</th>
                             <th width="100">Nom</th>
                             <th width="100">Position</th>
                             <th width="5">M</th>
                             <th width="5">F</th>
                             <th width="5">Ag</th>
                             <th width="5">Ar</th>
                             <th width="225">Compétences</th>
                             <th width="225">Evolutions</th>
                             <th width="20">Xp</th>
                             <th width="50">Prix Actuel</th>
                             <th width="50">Nb Saisons</th>
                             <template v-if="currentMode === 'read'">
                               <th width="50">Jet Départ</th>
                               <th width="50">Départ</th>
                               <th width="50">Annulation de BP</th>
                               <th width="50">Prix de réachat</th>
                             </template>
                             <template v-else>
                               <th colspan="2" width="50"></th>
                               <th width="50">Nb Saisons modif</th>
                             </template>
                             </tr>
                         </thead>
                        <tbody class="roster" >
                             <player-s-b-i-line v-for="player in current.players" :ref="'line_'+player.id" :player="player" :mode="currentMode" :season_break_info="getPlayerSBI(player.id)"/>
                             <tr>
                                 <td colspan="10" class="sous-total right">
                                      <div class="row columns">
                                          <div class="large-5 columns">{{current.players.length }} Joueurs Total - {{wounded}} Absents - {{journeymens}} journalier</div>
                                          <div class="large-1 large-offset-5 columns">total</div>
                                      </div>
                                 </td>
                                 <td class="sous-total">{{playersCost}}k</td>
                             </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          <template v-if="currentMode === 'write' ">
            <button class="light-grey-button" @click="currentMode = 'read'">Retour</button>
            <button class="validate" @click="updateCustomSBI()">Valider les customisations</button>
          </template>
            <div v-else id="stuff" class="row">
                <div class="large-5 columns large-offset-7">
                    <table>
                        <tbody class="roster">
                            <tr>
                                <td width="50"><img class="team-icon" src="/static/imgs/icons/dices.png" alt=""></td>
                                <td width="125">Relances</td>
                                <td width="110" >{{current.ref_roster.reroll_price}}k</td>
                                <td width="70">{{current.nb_rerolls}}</td>
                                <td width="150" >{{current.ref_roster.reroll_price*current.nb_rerolls}}k</td>
                            </tr>
                            <tr v-if="current.ref_roster.apo_available">
                                <td><img class="team-icon" src="/static/imgs/icons/red-cross.png" alt=""></td>
                                <td>Apothicaire</td>
                                <td>50 000</td>
                                <td v-if="current.apo">Oui</td>
                                <td v-else>Non</td>
                                <td v-if="current.apo">50k</td>
                                <td v-else>0k</td>
                            </tr>
                            <tr>
                                <td><img class="team-icon" src="/static/imgs/icons/glove.png" alt=""></td>
                                <td>Popularité</td>
                                <td>10k</td>
                                <td>{{current.pop}}</td>
                                <td>{{current.pop*10}}k</td>
                            </tr>
                            <tr>
                                <td><img class="team-icon" src="/static/imgs/icons/coach.png" alt=""></td>
                                <td>Assistants</td>
                                <td>10k</td>
                                <td>{{current.assistants}}</td>
                                <td>{{current.assistants*10}}k</td>
                            </tr>
                            <tr>
                                <td><img class="team-icon" src="/static/imgs/icons/pom-pom.png" alt=""></td>
                                <td>Pom-pom girls</td>
                                <td>10k</td>
                                <td>{{current.cheerleaders}}</td>
                                <td>{{current.cheerleaders*10}}k</td>
                            </tr>
                            <tr>
                                <td class="sous-total right" colspan="3">Budget Annexe</td>
                                <td></td>
                                <td v-if="current.apo == false" class="sous-total">{{current.ref_roster.reroll_price*current.nb_rerolls + current.pop*10 + current.assistants*10 + current.cheerleaders*10}} k</td>
                                <td v-else class="sous-total">{{50 + current.ref_roster.reroll_price*current.nb_rerolls + current.pop*10 + current.assistants*10 + current.cheerleaders*10}} k</td>
                                <td colspan="2"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import spinner from '../../../common/spinner.vue'
import messageModal from '../../../common/message-modal.vue'
import playerUpgradeModal from '../../../common/player-upgrade-modal.vue'
import { mapGetters } from 'vuex'
import seasonBreakInfo from '../../../../api/season-break-infos.api'
import playerSBILine from './player-season-break-line'
import teamSBIInfos from './team-season-break-infos'
import spinningModal from '../../../common/spinning-modal.vue'

export default {
  name: 'season-break-viewer',
  components: {
    spinner,
    spinningModal,
    playerUpgradeModal,
    messageModal,
    playerSBILine,
    teamSBIInfos
  },
  props: {
    'id': Number
  },
  data () {
    return {
      currentMode: 'read',
      showSpinner: false
    }
  },
  watch: {
    seasonBreakInfos: function (newSbi, oldSbi) {
      if (newSbi === null) {
        return
      }
      if (oldSbi === null && newSbi) {
        this.showSpinner = false
      }
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'seasonBreakInfos'
    ]),
    current: function () {
      return this.$store.getters.detailedTeam
    },
    wounded: function () {
      let woundedCpt = 0
      this.current.players.forEach(player => {
        if (player.miss_next_game) {
          woundedCpt++
        }
      })
      return woundedCpt
    },
    journeymens: function () {
      let journeymensCpt = 0
      this.current.players.forEach(player => {
        if (player.is_journeyman) {
          journeymensCpt++
        }
      })
      return journeymensCpt
    },
    playersCost: function (onlyPlaying = true) {
      let playerCost = 0
      this.current.players.forEach(player => {
        if (!onlyPlaying || !player.miss_next_game) {
          playerCost += (player.base_cost + player.evolution_cost)
        }
      })
      return playerCost
    }
  },
  created () {
    this.$store.dispatch('getSeasonBreakInfos', this.current.id.toString())
  },
  methods: {
    updateCustomSBI () {
      this.showSpinner = true
     // on va commencer par créer les customisations d'équipe
      // ensuite on va créer les customisations de chaque joueur
      let playerdatas = []
      this.current.players.forEach(p => {
        let refName = 'line_' + p.id
        let pDatas = this.$refs[refName][0].season_break_info.custom
        pDatas.custom_played_seasons = this.$refs[refName][0].played_season_offset
        playerdatas.push(pDatas)
      })
      seasonBreakInfo.api.updateCustomPlayerSBI(playerdatas)
      let datas = {
        'id': this.seasonBreakInfos.custom.id,
        'team': this.current.id,
        'additional_played_seasons': this.$refs.teamSBI.played_season_offset,
        'additional_played_matches': this.$refs.teamSBI.played_matches_offset,
        'additional_casualties': this.$refs.teamSBI.cas_offset,
        'additional_td': this.$refs.teamSBI.td_offset
      }

      seasonBreakInfo.api.updateCustomTeamSBI(datas)
        .then(response => {
          this.$store.dispatch('reloadSeasonBreakInfos', this.current.id.toString())
          this.currentMode = 'read'
        })
    },
    getUpgradeName (upgrade) {
      if (upgrade.status === 0) {
        return ''
      }
      if (upgrade.value === 0 || upgrade.value === 1) {
        return upgrade.skill
      }
      if (upgrade.value === 2) {
        return '+1 M'
      }
      if (upgrade.value === 3) {
        return '+1 Ar'
      }
      if (upgrade.value === 4) {
        return '+1 Ag'
      }
      if (upgrade.value === 5) {
        return '+1 F'
      }
    },
    getUpgradeStyle (upgrade) {
      if (upgrade.type === 0) {
        return 'upgrade base'
      }
      if (upgrade.type === 1) {
        if (upgrade.value === 0) {
          return 'upgrade simple'
        }
        if (upgrade.value === 1) {
          return 'upgrade double'
        }
        if (upgrade.value > 1) {
          return 'upgrade stats'
        }
      }
    },
    getDowngrades (player) {
      if (player.downgrades === null) {
        return ''
      }
      let dwngrd = ''
      if (player.downgrades['M'] !== 0) {
        dwngrd += '-' + player.downgrades['M'].toString(10) + 'M '
      }
      if (player.downgrades['F'] !== 0) {
        dwngrd += '-' + player.downgrades['F'].toString(10) + 'F '
      }
      if (player.downgrades['Ag'] !== 0) {
        dwngrd += '-' + player.downgrades['Ag'].toString(10) + 'Ag '
      }
      if (player.downgrades['Ar'] !== 0) {
        dwngrd += '-' + player.downgrades['Ar'].toString(10) + 'Ar '
      }
      return dwngrd
    },
    getRosterIcon (item) {
      return '/static/imgs/team-icons/' + item.ref_roster.name + '.png'
    },
    getPlayerSBI (playerId) {
      if (this.seasonBreakInfos === null) {
        return null
      }
      let found = this.seasonBreakInfos.players.find(psbi => {
        return psbi.player.id === playerId
      })
      return found
    },
    cancelSBI () {
      seasonBreakInfo.api.deleteSBI(this.seasonBreakInfos.id)
        .then(response => {
          this.$store.dispatch('reloadDetailedTeam')
          this.$router.push({
            name: 'TeamDetail',
            params: {
              id: this.current.id
            }
          })
        })
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.7rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.6rem;
}

.star tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size: 0.8rem;
    font-weight: 500;
    background-color: #E9EDEF;

}

.roster tr td.sous-total{
    font-weight: 600;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{
  margin-right: 0;
  padding-right:0;
  text-align: right;
}

.panel-top {
    padding-top: 0rem;
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.active {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// season-break-viewer.vue?564cb9ef